export default "__VITE_ASSET__D4FMkYf9__"